module.exports = __webpack_public_path__ + "static/media/credit-card-blank.b3e75495.svg";